module.exports = __webpack_public_path__ + "img/2.99586665.jpg";